'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        localizationCancel: {
            type: String,
            default: undefined,
            kComposite: 'localization.cancel'
        },
        localizationClearSelectedFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.clearSelectedFiles'
        },
        localizationDropFilesHere: {
            type: String,
            default: undefined,
            kComposite: 'localization.dropFilesHere'
        },
        localizationHeaderStatusUploaded: {
            type: String,
            default: undefined,
            kComposite: 'localization.headerStatusUploaded'
        },
        localizationHeaderStatusUploading: {
            type: String,
            default: undefined,
            kComposite: 'localization.headerStatusUploading'
        },
        localizationInvalidFileExtension: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidFileExtension'
        },
        localizationInvalidFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidFiles'
        },
        localizationInvalidMaxFileSize: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidMaxFileSize'
        },
        localizationInvalidMinFileSize: {
            type: String,
            default: undefined,
            kComposite: 'localization.invalidMinFileSize'
        },
        localizationRemove: {
            type: String,
            default: undefined,
            kComposite: 'localization.remove'
        },
        localizationRetry: {
            type: String,
            default: undefined,
            kComposite: 'localization.retry'
        },
        localizationSelect: {
            type: String,
            default: undefined,
            kComposite: 'localization.select'
        },
        localizationStatusFailed: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusFailed'
        },
        localizationStatusUploaded: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusUploaded'
        },
        localizationStatusUploading: {
            type: String,
            default: undefined,
            kComposite: 'localization.statusUploading'
        },
        localizationUploadSelectedFiles: {
            type: String,
            default: undefined,
            kComposite: 'localization.uploadSelectedFiles'
        }
    }
};